import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {ModalService} from '@core/services';

@Component({
  selector: 'core-confirm',
  imports: [],
  templateUrl: './confirm.html',
  styleUrl: './confirm.scss',
  host: {
    style: 'width: 100%;display: flex;flex-direction: column;gap: 0.5rem;background:var(--background-color)'
  }
})
export class Confirm {

  @Input() title: string = '';
  @Input() description = '';
  @Input() confirmText = 'Confirm';
  @Input() cancelText = 'Cancel';
  @Input() showCancel = true;
  @Input() showConfirm = true;

  @Output() close = new EventEmitter();
  @Output() confirm = new EventEmitter();

  private readonly modal = inject(ModalService);

  onClose() {
    this.modal.closeTop();
    this.close.emit();
  }

  onConfirm() {
    this.modal.closeTop();
    this.confirm.emit();
  }

}
